<template>
  <div id="amc-report-setting-form">
    <HorizontalFieldLayout
      label="カテゴリー"
      class="mb-10"
    >
      <SelectField
        v-model="innerCategory"
        name="カテゴリー"
        rules="required"
        :options="categoryOptions"
        :searchable="false"
      />
      <div>
        <p class="mt-2">RFM分析のレポート作成で使用する商品グループを指定します。</p>
      </div>
    </HorizontalFieldLayout>
    <HorizontalFieldLayout
      label="RFMユーザーランク"
      class="mb-10"
    >
      <div class="rfm-user-rank-layout grid gap-6">
        <div class="flex items-center">
          <p class="mr-5">優良ユーザー</p>
        </div>
        <div class="flex items-center">
          <InputField
            v-model="innerExcellentUserDay"
            rules="required|integer|min_value:30|max_value:90"
            name="優良ユーザー購入日"
            class="mr-5"
          />
          <div class="mt-1">
            日以内に購入している。
          </div>
        </div>
        <div></div>
        <div class="flex items-center">
          <InputField
            v-model="innerExcellentUserPurchase"
            rules="required|integer|min_value:3|max_value:10"
            name="優良ユーザー購入回数"
            class="mr-5"
          />
          <div class="mt-1">
            回以上購入している。（過去1年）
          </div>
        </div>
        <div class="flex items-center">
          <p class="mr-5">休眠ユーザー</p>
        </div>
        <div class="flex items-center">
          <InputField
            v-model="innerDormantUserDay"
            rules="required|integer|min_value:90|max_value:180|comparison:@優良ユーザー購入日,31"
            name="休眠ユーザー"
            class="mr-5"
          />
          <div class="mt-1">
            日以上購入していない。
          </div>
        </div>
      </div>
    </HorizontalFieldLayout>
    <HorizontalFieldLayout
      label="広告ARPU日数"
      class="mb-10"
    >
      <div class="flex items-center">
        <InputField
          v-model="innerArpuDay"
          rules="required|integer|min_value:30|max_value:360"
          name="広告ARPU日数"
          class="mr-5"
        />
        <div class="mt-1">
          日以内
        </div>
      </div>
      <div>
        <p class="mt-2">広告クリック後、何日以内のリピート購入をARPUに対象とするか指定します。</p>
      </div>
    </HorizontalFieldLayout>
    <HorizontalFieldLayout
      label="Paid features：Amazon insights"
      class="mb-10"
    >
      <div class="flex items-center">
        <SwitchField
          v-model="innerIsPaidTable"
          name="Paid features：Amazon insights"
          class="mr-5"
        />
      </div>
    </HorizontalFieldLayout>
  </div>
</template>

<script>
import InputField from '@/components/fields/InputField'
import SelectField from '@/components/fields/SelectField'
import SwitchField from '@/components/fields/SwitchField'
import HorizontalFieldLayout from '@/components/layouts/form/HorizontalFieldLayout'

export default {
  name: 'AmcReportSettingForm',
  components: {
    InputField,
    SelectField,
    SwitchField,
    HorizontalFieldLayout
  },
  props: {
    category: {
      type: String,
      default: null
    },
    excellentUserDay: {
      type: String,
      default: null
    },
    excellentUserPurchase: {
      type: String,
      default: null
    },
    dormantUserDay: {
      type: String,
      default: null
    },
    arpuDay: {
      type: String,
      default: null
    },
    isPaidTable: {
      type: Number,
      default: 0
    }
  },
  emits: [
    'update:category',
    'update:excellent-user-day',
    'update:excellent-user-purchase',
    'update:dormant-user-day',
    'update:arpu-day',
    'update:is-paid-table'
  ],
  computed: {
    innerCategory: {
      get () {
        return this.category
      },
      set (value) {
        this.$emit('update:category', value)
      }
    },
    innerExcellentUserDay: {
      get () {
        return this.excellentUserDay
      },
      set (value) {
        this.$emit('update:excellent-user-day', value)
      }
    },
    innerExcellentUserPurchase: {
      get () {
        return this.excellentUserPurchase
      },
      set (value) {
        this.$emit('update:excellent-user-purchase', value)
      }
    },
    innerDormantUserDay: {
      get () {
        return this.dormantUserDay
      },
      set (value) {
        this.$emit('update:dormant-user-day', value)
      }
    },
    innerArpuDay: {
      get () {
        return this.arpuDay
      },
      set (value) {
        this.$emit('update:arpu-day', value)
      }
    },
    innerIsPaidTable: {
      get () {
        return this.isPaidTable
      },
      set (value) {
        this.$emit('update:is-paid-table', value)
      }
    },
    categoryOptions () {
      return [
        { value: 'brand', text: 'ブランド' },
        { value: 'seller_category', text: '出品者カテゴリー1' },
        { value: 'seller_category2', text: '出品者カテゴリー2' },
        { value: 'seller_category3', text: '出品者カテゴリー3' },
        { value: 'seller_category4', text: '出品者カテゴリー4' },
        { value: 'seller_category5', text: '出品者カテゴリー5' }
      ]
    }
  },
  methods: {
    onFilterChange (index, value) {
      this.$emit('update:report-filters', [
        ...this.reportFilters.slice(0, index),
        {
          ...this.reportFilters[index],
          ...value
        },
        ...this.reportFilters.slice(index + 1)
      ])
    }
  }
}
</script>

<style scoped>
#amc-report-setting-form .horizontal-field-layout {
  align-items: self-start;
}
.rfm-user-rank-layout {
  grid-template-columns: 120px 1fr;
}
</style>
